// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".n_G1K_4N_AxpIH {\n  background: var(--ds-surface-overlay, #FFFFFF);\n  border-radius: 4px;\n  box-shadow: var(--ds-shadow-raised, 0 1px 2px rgba(0, 0, 0, 0.2));\n  box-sizing: content-box;\n  color: var(--ds-text, #172B4D);\n  max-height: 300px;\n  max-width: 300px;\n  padding: 8px 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipPrimitiveLight": "n_G1K_4N_AxpIH"
};
export default ___CSS_LOADER_EXPORT___;
